import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getWebhooks() {
  return axios.get('/ajax/onboarding_webhooks')
}

export function createWebhook(data) {
  return axios.post('/ajax/onboarding_webhooks', data)
}

export function updateWebhook(id, data) {
  return axios.patch(`/ajax/onboarding_webhooks/${id}`, data)
}

export function deleteWebhook(id) {
  return axios.delete(`/ajax/onboarding_webhooks/${id}`)
}

export function toggleWebhook(id) {
  return axios.patch(`/ajax/onboarding_webhooks/${id}/toggle`)
}

export function testWebhook(id) {
  return axios.post(`/ajax/onboarding_webhooks/${id}/test`)
}

export function getDeliveries(id) {
  return axios.get(`/ajax/onboarding_webhooks/${id}/deliveries`)
}
